export class ValidationMessages {
  private static errorMessages: ValidationMessages = null;

  private config = {
    flightNumber: {
      required: 'FLIGHT_NUM_INVALID',
      pattern: 'FLIGHT_NUM_INVALID',
      maxlength: 'FLIGHT_NUM_INVALID',
      invalidflight: 'FLIGHT_NUM_INVALID',
      eitherflightnumberorairports: 'FLIGHT_NUM_REQD'
    },
    flightStatusWidgetForm: {
      eitherflightnumberorairports: 'FLIGHT_NUM_REQD'
    },
    fromAirportName: {
      required: 'FROM_CITY_REQD',
      fromrequired: 'FROM_CITY_REQD',
      invalidairportcode: 'AIRPORT_CODE_INVALID'
    },
    toAirportName: {
      required: 'TO_CITY_REQD',
      torequired: 'FROM_CITY_REQD',
      invalidairportcode: 'AIRPORT_CODE_INVALID'
    },
    airports: {
      sameairports: 'INVALID_FROMTO',
      pattern: 'AIRPORT_CODE_INVALID',
      bothrequired: 'FROM_TO_CITY_REQD',
      fromrequired: 'FROM_CITY_REQD',
      torequired: 'TO_CITY_REQD'
    },
    connectionAirport: {
      sameasfromto: 'INVALID_CONNECTION_AIRPORT'
    },
    bookWidgetForm: {
      bothrequired: 'FROM_TO_CITY_REQD'
    },
    search: {
      pattern: 'AIRPORT_CODE_INVALID'
    },
    departureDate: {
      required: 'FLIGHT_DATE_REQD',
      bothrequired: 'START_RETURN_DATE_REQD',
      returndaterequired: 'RETURN_DATE_REQD',
      invalidflightdate: 'MULTI_CITY_DATE_INVALID'
    },
    confirmationNumber: {
      required: 'CONF_NUM_REQD',
      pattern: 'CONF_NUM_INVALID',
      maxlength: 'CONF_NUM_INVALID',
      minlength: 'CONF_NUM_INVALID'
    },
    meetingEventCode: {
      pattern: 'MEETING_CODE_INVALID',
      maxlength: 'MEETING_CODE_INVALID',
      minlength: 'MEETING_CODE_INVALID'
    },
    creditcardNumber: {
      required: 'CCNUM_REQD',
      pattern: 'CCNUM_INVALID',
      maxlength: 'CCNUM_INVALID',
      minlength: 'CCNUM_INVALID'
    },
    eticketNumber: {
      required: 'TICKET_NUM_REQD',
      pattern: 'TICKET_NUM_INVALID',
      maxlength: 'TICKET_NUM_INVALID',
      minlength: 'TICKET_NUM_INVALID'
    },
    skymilesNumber: {
      required: 'SKYMILES_NUMREQD',
      pattern: 'SKYMILES_NUM_INVALID',
      maxlength: 'SKYMILES_NUM_INVALID'
    },
    lastName: {
      required: 'LAST_NAME_REQD',
      pattern: 'LAST_NAME_INVALID',
      maxlength: 'LAST_NAME_INVALID'
    },
    departureAirport: {
      required: 'FROM_CITY_REQD'
    },
    confirmationNo: {
      required: 'CONF_NUM_REQD',
      pattern: 'CONF_NUM_INVALID',
      maxlength: 'CONF_NUM_INVALID',
      minlength: 'CONF_NUM_INVALID'
    },
    cardNo: {
      required: 'CCNUM_REQD',
      pattern: 'CCNUM_INVALID',
      maxlength: 'CCNUM_INVALID',
      minlength: 'CCNUM_INVALID'
    },
    eTicketNo: {
      required: 'TICKET_NUM_REQD',
      pattern: 'TICKET_NUM_INVALID',
      maxlength: 'TICKET_NUM_INVALID',
      minlength: 'TICKET_NUM_INVALID'
    },
    firstName: {
      required: 'FIRST_NAME_REQD',
      pattern: 'FIRST_NAME_INVALID',
      maxlength: 'FIRST_NAME_INVALID'
    },
    passenger: {
      maxCount: 'PAX_CNT_INVALID',
      infantCount: 'INF_CNT_INVALID',
      adtCount: 'ADT_CNT_INVALID'
    }
  };

  static getInstance(): ValidationMessages {
    if (!ValidationMessages.errorMessages) {
      ValidationMessages.errorMessages = new ValidationMessages();
    }
    return ValidationMessages.errorMessages;
  }

  getValidatorErrorMessage(
    validatorName: string,
    fieldname: string,
    validatorValue?: any
  ) {
    if (validatorName === 'remote') {
      return validatorValue;
    } else {
      const messages = this.config[fieldname];
      return messages[validatorName];
    }
  }
}
